import script from "./repair-order-claim-information.vue?vue&type=script&lang=ts&setup=true"
export * from "./repair-order-claim-information.vue?vue&type=script&lang=ts&setup=true"

import "./repair-order-claim-information.vue?vue&type=style&index=0&id=4dd3451e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd3451e"]])

export default __exports__